var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#3b7cc9"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm1 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-2 7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2v-4a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2v3Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;